// Fa riempire a ogni foto prodotto il suo riquadro nello stesso modo,
// usando il "contenuto utile" misurato su ogni immagine (in % della foto: x1, y1, x2, y2).
// Così la card in italiano, quella in inglese e il retro 3M appaiono tutte della stessa grandezza.
(() => {
  const BOX = {
    'A498CD7C-D3AB-48A3-BFDF-2253C3E18EB7.png': [11.2, 10.0, 90.5, 87.5],
    'unnamed.png': [9.5, 11.0, 92.2, 92.0],
    '25473793-206D-4E8C-865A-62655CAC1679.png': [21.8, 18.0, 78.2, 82.7, 'frame'],
    'IMG_0190.jpg': [13.2, 12.5, 87.0, 89.7],
    '56B3F454-3DA6-4BBB-8914-C56A51F651A2.png': [13.3, 12.5, 87.0, 89.7],
    'ImmagineChatGPT27set2026_14_33_29.png': [8.3, 8.7, 94.3, 87.5],
    'Immagine_ChatGPT_27_set_2026_14_28_56.png': [7.2, 8.5, 92.3, 92.5],
    '204CB849-1FC3-4242-98D8-0BF0CC5DE041.png': [0, 0, 100, 100],
    'unnamed_2.png': [0, 0, 100, 100],
  };
  window.tapFit = (img, file, fill = 0.86) => {
    if (String(file).startsWith('25473793')) fill = Math.min(fill, 0.8);
    const key = String(file).split('?')[0].split('/').pop();
    const b = BOX[key] || [0, 0, 100, 100];
    const full = b[2] - b[0] >= 99 && b[3] - b[1] >= 99;
    const run = () => {
      const box = img.parentElement, S = box.clientWidth, H = box.clientHeight;
      const ar = (img.naturalWidth || 1) / (img.naturalHeight || 1);
      if (!S || !H) return;
      if (full) { // foto già a tutto riquadro: copre e basta
        box.querySelector(':scope > .ffr')?.remove(); img.style.clipPath = '';
        const w = Math.max(S, H * ar);
        Object.assign(img.style, { width: w + 'px', left: (S - w) / 2 + 'px', top: (H - w / ar) / 2 + 'px' });
        return;
      }
      const cw = (b[2] - b[0]) / 100, ch = (b[3] - b[1]) / 100;
      // larghezza della foto perché il contenuto occupi "fill" del riquadro
      const w = Math.min((S * fill) / cw, (H * fill) / (ch / ar));
      const h = w / ar;
      const cx = (b[0] + b[2]) / 200, cy = (b[1] + b[3]) / 200;
      const L = S / 2 - cx * w, T = H / 2 - cy * h;
      Object.assign(img.style, { width: w + 'px', left: L + 'px', top: T + 'px' });
      // foglio bianco su fondo bianco: ritaglio il foglio (via gli angoli bianchi della foto)
      // e gli disegno un bordo leggero con ombra per farlo vedere
      let fr = box.querySelector(':scope > .ffr');
      if (b[4] === 'frame') {
        const d = cw * w * .025, x1 = b[0] / 100 * w + d, y1 = b[1] / 100 * h + d, x2 = b[2] / 100 * w - d, y2 = b[3] / 100 * h - d;
        const r = Math.round((x2 - x1) * .04);
        img.style.clipPath = `inset(${y1}px ${w - x2}px ${h - y2}px ${x1}px round ${r}px)`;
        if (!fr) { fr = document.createElement('span'); fr.className = 'ffr'; img.after(fr); }
        Object.assign(fr.style, { position: 'absolute', pointerEvents: 'none', left: L + x1 + 'px', top: T + y1 + 'px', width: x2 - x1 + 'px', height: y2 - y1 + 'px',
          borderRadius: r + 'px', boxShadow: '0 0 0 1px rgba(13,26,58,.10), 0 22px 34px -20px rgba(13,26,58,.45)' });
      } else { img.style.clipPath = ''; if (fr) fr.remove(); }
    };
    img._fit = run;
    run();
  };
})();
